// extracted by mini-css-extract-plugin
module.exports = {"home-page":"styles_home-page__3SRAr"};